import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Badge,
  Card,
  CardHeader,
  CardBody,
  Divider,
  Icon,
  Button,
  SimpleGrid,
} from '@chakra-ui/react';
import { CheckCircleIcon, InfoOutlineIcon, ArrowRightIcon } from '@chakra-ui/icons';

const FqPaDemoWrapCompliance = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading size="lg" color="brand.700" mb={2}>Medicare Advantage Wrap Compliance</Heading>
          <Text color="gray.600">
            Detecting missed Medicare Advantage supplemental wrap payments (Rev 0519) for dual-eligible encounters \u2014 the wrap is paid by Medicare (Novitas JL), not Medicaid.
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
          {/* Left Column: The Scenario */}
          <VStack align="stretch" spacing={6}>
            <Card variant="outline" bg="white" borderColor="red.200">
              <CardHeader bg="red.50" pb={2}>
                <HStack justify="space-between">
                  <HStack>
                    <Icon as={InfoOutlineIcon} color="red.500" />
                    <Heading size="sm" color="red.700">Missed Revenue Detected</Heading>
                  </HStack>
                  <Badge colorScheme="red">Action Required</Badge>
                </HStack>
              </CardHeader>
              <CardBody>
                <VStack align="stretch" spacing={4}>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm" color="gray.500">Patient</Text>
                    <Text>Walter Brooks (DOB: 09/02/1952) \u2014 dual eligible (QMB), Keystone 65 HMO</Text>
                  </Box>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm" color="gray.500">Primary Payer (Medicare Advantage)</Text>
                    <Text>Paid: $89.00 (MA Contracted Rate)</Text>
                  </Box>
                  <Box>
                    <Text fontWeight="bold" fontSize="sm" color="gray.500">Medicare FQHC PPS Rate (GAF-adjusted)</Text>
                    <Text>$198.42</Text>
                  </Box>
                  <Divider />
                  <HStack justify="space-between">
                    <Text fontWeight="bold" color="red.600">Missed Wrap Opportunity</Text>
                    <Text fontWeight="bold" color="red.600">$109.42</Text>
                  </HStack>
                </VStack>
              </CardBody>
            </Card>

            <Card variant="outline" bg="blue.50" borderColor="blue.200">
              <CardBody>
                <HStack align="start">
                  <Icon as={InfoOutlineIcon} color="blue.500" mt={1} />
                  <Box>
                    <Text fontWeight="bold" color="blue.800" mb={2}>Medicare Rule Citation</Text>
                    <Text fontSize="sm" color="blue.700" fontStyle="italic">
                      "For claims with the 0519 revenue code, when the MA contract rate is lower than the PPS rate, the contractor pays the difference \u2014 minus any cost-sharing owed by the beneficiary \u2014 as a supplemental wraparound payment. QMB dual-eligibles owe no cost-sharing. If the plan\u2019s supplemental rate is not on file, the claim returns with reason code 37098 until MA contract documentation is submitted."
                    </Text>
                    <Text fontSize="xs" color="blue.600" mt={2}>
                      Source: CMS FQHC PPS FAQ; Medicare Claims Processing Manual Ch. 9; MAC guidance (Novitas JL for PA)
                    </Text>
                  </Box>
                </HStack>
              </CardBody>
            </Card>
          </VStack>

          {/* Right Column: The Revedy Solution */}
          <Card variant="outline" bg="white" borderColor="green.200">
            <CardHeader bg="green.50" pb={2}>
              <HStack justify="space-between">
                <HStack>
                  <Icon as={CheckCircleIcon} color="green.500" />
                  <Heading size="sm" color="green.700">Revedy Auto-Drafted Claim</Heading>
                </HStack>
                <Badge colorScheme="green">Ready to Submit</Badge>
              </HStack>
            </CardHeader>
            <CardBody>
              <VStack align="stretch" spacing={6}>
                <Text fontSize="sm" color="gray.600">
                  Revedy has automatically generated the supplemental wrap claim to Novitas (JL), applying the correct revenue code and G-code, and suppressing beneficiary cost-sharing for the QMB dual.
                </Text>

                <Box borderWidth="1px" borderRadius="md" p={4} bg="gray.50">
                  <VStack align="stretch" spacing={3}>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Revenue Code</Text>
                      <Badge colorScheme="purple">0519 (Clinic \u2014 Other)</Badge>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">HCPCS Code</Text>
                      <Badge colorScheme="blue">G0467 (FQHC, established)</Badge>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Beneficiary Cost-Share</Text>
                      <Badge colorScheme="orange">$0.00 (QMB \u2014 do not bill)</Badge>
                    </HStack>
                    <Divider />
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Prior Payments (EOB)</Text>
                      <Text fontSize="sm">$89.00 (Keystone 65 EOB)</Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text fontWeight="bold" fontSize="sm">Billed Amount</Text>
                      <Text fontSize="sm" fontWeight="bold" color="green.600">$109.42</Text>
                    </HStack>
                  </VStack>
                </Box>

                <Button colorScheme="green" size="lg" rightIcon={<ArrowRightIcon />}>
                  Approve & Submit Wrap Claim
                </Button>
              </VStack>
            </CardBody>
          </Card>
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default FqPaDemoWrapCompliance;
